<template>
  <UiRow align="center" class="ma-n2">
    <UiCol v-for="(social, index) in socials" :key="index" class="pa-2">
      <SocialListItem :social="social" />
    </UiCol>
  </UiRow>
</template>

<script setup lang="ts">
import { UiRow, UiCol } from '~/ui';
import SocialListItem from '~/domains/social/components/SocialList/SocialListItem.vue';
import { type Social } from '~/domains/core';

export interface Props {
  socials: Social[];
}
defineProps<Props>();
</script>
